import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import { productPages, productPagePath } from '../data/productPages';
import './CategoryGrid.css';

// One-click links to every product category page. `exclude` hides the current category.
function CategoryGrid({ exclude, showAllCard = false, headingLevel = 'h3' }) {
  const Heading = headingLevel;
  const pages = productPages.filter((p) => p.slug !== exclude);

  return (
    <div className="category-grid">
      {pages.map((page) => (
        <Link key={page.slug} to={productPagePath(page)} className="category-card">
          <div className="category-card-media">
            {page.image ? (
              <img src={page.image} alt={`${page.name} in stock at OJANNA, George`} loading="lazy" width="800" height="530" />
            ) : (
              <div className="category-card-icon">
                <Icon name={page.icon} size={40} strokeWidth={1.6} />
              </div>
            )}
          </div>
          <div className="category-card-body">
            <Heading>{page.name}</Heading>
            <p>{page.summary}</p>
            <span className="category-card-go">
              View range <Icon name="arrow" size={16} />
            </span>
          </div>
        </Link>
      ))}
      {showAllCard && (
        <Link to="/products" className="category-card category-card-all">
          <div className="category-card-body">
            <Heading>All products</Heading>
            <p>Browse the full range with features, brands and applications.</p>
            <span className="category-card-go">
              See everything <Icon name="arrow" size={16} />
            </span>
          </div>
        </Link>
      )}
    </div>
  );
}

export default CategoryGrid;
